import { Component } from '@angular/core';
import { FormFieldSate } from '../form-field.state';

@Component({
  selector: 'app-checkbox-switch-form-field',
  templateUrl: './checkbox-switch-form-field.component.html',
  styleUrls: ['./checkbox-switch-form-field.component.scss'],
})
export class CheckboxSwitchFormFieldComponent extends FormFieldSate {
  public checked = false;

  public override ngOnInit(): void {
    super.ngOnInit();
    this.toggleControl(this.control.value as boolean);
  }

  public toggleControl(value: boolean): void {
    this.control.setValue(value);
    this.control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
    this.checked = this.control.value as boolean;
  }
}
